import { useRef, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Magnetic button — subtly follows the cursor when hovered.
 * Renders as a <button> or, if `as` provided, that element.
 */
export const MagneticButton = ({
  children,
  className = "",
  strength = 0.4,
  as: Component = "button",
  ...props
}) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const handleMove = (e) => {
    if (reduce || !ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const x = e.clientX - (rect.left + rect.width / 2);
    const y = e.clientY - (rect.top + rect.height / 2);
    setPos({ x: x * strength, y: y * strength });
  };

  const reset = () => setPos({ x: 0, y: 0 });

  const MotionComp = motion(Component);

  return (
    <MotionComp
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={reset}
      animate={{ x: pos.x, y: pos.y }}
      transition={{ type: "spring", stiffness: 260, damping: 18, mass: 0.4 }}
      className={className}
      {...props}
    >
      {children}
    </MotionComp>
  );
};
